var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Paginator',_vm._b({on:{"change-page":_vm.changePage,"next-page":_vm.nextPage,"prev-page":_vm.prevPage}},'Paginator',_vm.properties,false))
}
var staticRenderFns = []

export { render, staticRenderFns }